// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\DashboardStatsResponse

export type DashboardStatsApiResponse = {
	bookings: Array<{ count: number; sum_pax?: number; dateGroup: string; origin?: string; status?: string }>;
	bookingsByCreatedAt: Array<{ count: number; sum_pax?: number; dateGroup: string; origin?: string; status?: string }>;
	bookingRevenues: Array<{ dateGroup: string; revenue: number }>;
	topOffers: Array<{ id: string; color: string; count: number; sum_pax: number }>;
	clientStats: Array<{ total_clients: number; new_clients: number; dateGroup: string }>;
	payments: Array<{ count: number; sum_amount: number; sum_fee: number; avg_amount: number; dateGroup: string; type?: string }>;
	onlinePayments: Array<{ count: number; sum_amount: number; sum_fee: number; avg_amount: number; dateGroup: string; type?: string }>;
	clientRatings: Array<{ averageRating: number; reviewCount: number; dateGroup: string }>;
	clientRatingsAverage: { averageRating: number; reviewCount: number };
	clientRatingsSplit: Record<string, number>;
	attendance: Array<{ dayOfWeek: number; hourOfDay: number; count: number; sum_pax: number }>;
	leadTimes: Array<{ daysInAdvance: number; count: number; sum_pax: number }>;
	giftcardStats: { sold: number; income: number; remaining: number };
	packageStats: { sold: number; income: number; remaining: number };
};

export type DashboardStats = {
	bookings: Array<{ count: number; sum_pax?: number; dateGroup: string; origin?: string; status?: string }>;
	bookingsByCreatedAt: Array<{ count: number; sum_pax?: number; dateGroup: string; origin?: string; status?: string }>;
	bookingRevenues: Array<{ dateGroup: string; revenue: number }>;
	topOffers: Array<{ id: string; color: string; count: number; sum_pax: number }>;
	clientStats: Array<{ total_clients: number; new_clients: number; dateGroup: string }>;
	payments: Array<{ count: number; sum_amount: number; sum_fee: number; avg_amount: number; dateGroup: string; type?: string }>;
	onlinePayments: Array<{ count: number; sum_amount: number; sum_fee: number; avg_amount: number; dateGroup: string; type?: string }>;
	clientRatings: Array<{ averageRating: number; reviewCount: number; dateGroup: string }>;
	clientRatingsAverage: { averageRating: number; reviewCount: number };
	clientRatingsSplit: Record<string, number>;
	attendance: Array<{ dayOfWeek: number; hourOfDay: number; count: number; sum_pax: number }>;
	leadTimes: Array<{ daysInAdvance: number; count: number; sum_pax: number }>;
	giftcardStats: { sold: number; income: number; remaining: number };
	packageStats: { sold: number; income: number; remaining: number };
};

export function hydrateDashboardStats(data: DashboardStatsApiResponse): DashboardStats {
	return {
		...data,
		clientRatingsSplit: Array.isArray(data.clientRatingsSplit) ? {} : data.clientRatingsSplit,
	};
}